export default __webpack_public_path__ + "static/media/QewdNewLogo.22fccc4a.svg";